import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetch from "auth/FetchInterceptor";

export const getAllGarages = createAsyncThunk(
  "garage/getAllGarage",
  async ({ page = 1, limit = 10, localisation = "" }, { rejectWithValue }) => {
    try {
      const response = await fetch({
        url: `/garage/all?page=${page}&limit=${limit}&localisation=${encodeURIComponent(
          localisation
        )}`,
        method: "get",
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error || "Erreur lors du chargement"
      );
    }
  }
);

export const addGarage = createAsyncThunk(
  "garage/addGarage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await fetch({
        url: "/garage/create",
        method: "post",
        data,
      });
      return response;
    } catch (error) {
      const status = error?.response?.status;

      if (status === 400) {
        return rejectWithValue("Ce garage existe déjà.");
      }

      return rejectWithValue("Erreur inconnue");
    }
  }
);

export const deleteGarage = createAsyncThunk(
  "garage/deleteGarage",
  async (id, { rejectWithValue }) => {
    try {
      await fetch({ url: `/garage/delete/${id}`, method: "delete" });
      return id;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error || "Erreur à la suppression"
      );
    }
  }
);

export const updateGarage = createAsyncThunk(
  "garage/updateGarage",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await fetch({
        url: `/garage/updateById/${id}`,
        method: "put",
        data,
      });

      return { id, response };
    } catch (error) {
      const status = error?.response?.status;

      if (status === 400) {
        return rejectWithValue("Ce garage existe déjà.");
      }

      return rejectWithValue("Erreur inconnue");
    }
  }
);

const garageSlice = createSlice({
  name: "garage",
  initialState: {
    garages: [],
    total: 0,
    page: 1,
    totalPages: 1,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetGaragesState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllGarages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllGarages.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.garages = payload.data;
        state.total = payload.total;
        state.page = payload.page;
        state.totalPages = payload.totalPages;
        // console.log();
      })
      .addCase(getAllGarages.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(addGarage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addGarage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;

        state.garages.unshift(payload);
        state.total += 1;
      })
      .addCase(addGarage.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      });

    builder
      .addCase(deleteGarage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteGarage.fulfilled, (state, { payload: deletedId }) => {
        state.loading = false;
        state.success = true;

        state.garages = state.garages.filter((m) => m.id !== deletedId);
        state.total -= 1;
      })
      .addCase(deleteGarage.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      });

    builder
      .addCase(updateGarage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateGarage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;

        const idx = state.garages.findIndex((m) => m.id === payload.id);
        if (idx !== -1) {
          state.garages[idx] = payload.updated;
        }
      })
      .addCase(updateGarage.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      });
  },
});

export const { resetGaragesState } = garageSlice.actions;
export default garageSlice.reducer;
